/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface MgmDashboardSummaryDTO {
  claimsCancelledInPeriod?: number;
  claimsConqueredInPeriod?: number;
  claimsShippedInPeriod?: number;
  cutoverDate?: Date;
  giftsAssignedPendingShip?: number;
  giftsInGracePeriod?: number;
  giftsReadyToShip?: number;
  giftsShippedTotal?: number;
  giftsWaitingStock?: number;
  invitesActiveInPeriod?: number;
  invitesRevertedInPeriod?: number;
  participantsTotal?: number;
  participantsWithActivityInPeriod?: number;
  periodFrom?: Date;
  periodTo?: Date;
}
